import {Map, InfoWindow, Marker, GoogleApiWrapper,Polyline} from 'google-maps-react';
import React from "react";
import Service from "src/api/Service"
import { Modal, Button } from 'react-bootstrap';
import AlertComponent from './AlertComponent';
class MapContainer extends React.Component {
  state = {
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
    allCompany:[],
    AllLines:[],
    isLoading:true,
    AlertVisible:false,
    markerData:[]
  };
 
  onMarkerClick = (props, marker, e) =>{
    console.log(props);
    
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      markerData:props,
      AlertVisible : !this.state.AlertVisible
  
    });
  }

 
  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  };

   async getAll(){
    await Service.get("/alert_dashboard/googleMap",(status,data)=>{
      var data=data[0];
    
      if(status==200){
        var dataSet=[]
         data['data'].map((e,index)=>{
          console.log(e['listAll']['iconType']);
          console.log(e['listAll']['alertFlag']);
          e.latitude=e['source']['lat'];
          e.longitude=e['source']['lng'];
          e.name=e['listAll']['name'];     
           var icon=  e['listAll']['alertFlag']=='A'? require("src/assets/icons/PlantA.png"):require("src/assets/icons/Plant.png");
           var size= new window.google.maps.Size(24,24);
           if(e.latitude!=null || e.longitude != null){

            if(e['listAll']['iconType']=="Regional Office" || e['listAll']['iconType']=="Branch" || e['listAll']['iconType']=="factory" ){
              
              var icon= e['listAll']['alertFlag']=='A'? require("src/assets/icons/supplierA.png"):require("src/assets/icons/supplier.png");
              var size= new window.google.maps.Size(11,11);
              dataSet.push( <Marker
                title={e.name}                
                name={e.name}
                position={{lat: e.latitude, lng: e.longitude}}
                onClick={this.onMarkerClick}
                icon={{
                  url:  icon,
                  anchor:new window.google.maps.Point(4, 7),
                  fillColor: '#EB00FF',
                  scale: 7,
                   scaledSize: size
                }}
                />
                );

            }else if(e['listAll']['iconType']=="warehouse"){

              var size= new window.google.maps.Size(12,12);
              var icon=  e['listAll']['alertFlag']=='A'? require("src/assets/icons/warehouseA.png"): require("src/assets/icons/warehouse.png");
              dataSet.push( <Marker
                title={e.name}                
                name={e.name}
                position={{lat: e.latitude, lng: e.longitude}}
                onClick={this.onMarkerClick}
                icon={{
                  url:  icon,
                  anchor:new window.google.maps.Point(8, 11),
                  fillColor: '#EB00FF',
                  scale: 7,
                   scaledSize: size
                }}
                />
                );

            }else if(e['listAll']['iconType']=="plant"){
              var size= new window.google.maps.Size(16,16);
              var icon=  e['listAll']['alertFlag']=='A'? require("src/assets/icons/PlantA.png"): require("src/assets/icons/Plant.png");
              dataSet.push( <Marker
                title={e.name}                
                name={e.name}
                position={{lat: e.latitude, lng: e.longitude}}
                onClick={this.onMarkerClick}
                icon={{
                  url:  icon,
                  anchor:new window.google.maps.Point(4, 11),
                  fillColor: '#EB00FF',
                  scale: 7,
                   scaledSize: size
                }}
                />
                );

            }
            else if(e['listAll']['iconType']=="depot"){
              var size= new window.google.maps.Size(16,16);
              var icon=  e['listAll']['alertFlag']=='A'? require("src/assets/icons/customerA.png"): require("src/assets/icons/customer.png");
              dataSet.push( <Marker
                title={e.name}                
                name={e.name}
                position={{lat: e.latitude, lng: e.longitude}}
                onClick={this.onMarkerClick}
                icon={{
                  url:  icon,
                  anchor:new window.google.maps.Point(7, 8),
                  fillColor: '#EB00FF',
                  scale: 7,
                   scaledSize: size
                }}
                />
                );

            }
           

           }

         })
       this.setState({
        allCompany:dataSet,
        AllLines:data['line'],
        isLoading:false,
       })
      }
  }); 
  }

  componentDidMount(){
    this.getAll();
  }

  createCenterControl(map) {
    const controlButton = document.createElement("div");
  
    // Set CSS for the control.
    controlButton.className = "mapInfo";
    controlButton.style.backgroundColor = "#fff";
    controlButton.style.border = "2px solid #fff";
    controlButton.style.borderRadius = "3px";
    controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlButton.style.color = "rgb(25,25,25)";
    controlButton.style.cursor = "pointer";
    controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
    controlButton.style.fontSize = "10px";
    controlButton.style.lineHeight = "2px";
    controlButton.style.margin = "1px 0 2px";
    controlButton.style.padding = "5px 5px";
    controlButton.style.textAlign = "left";

    var icon= require("src/assets/icons/supplier.png");
     var Regional = document.createElement('p'); // is a node
     var img = document.createElement('img');
       img.src = icon;
       img.width = '11';
       img.height = '11';
      Regional.appendChild(img);
      var text = document.createElement('span'); 
      text.innerHTML = ' Supplier';
      Regional.appendChild(text);

     var Plant = document.createElement('p'); // is a node
     var icon= require("src/assets/icons/Plant.png");
     var img = document.createElement('img');
     img.src = icon;
     img.width = '14';
     img.height = '14';
     Plant.appendChild(img);
     var text = document.createElement('span'); 
      text.innerHTML = ' Plant';
      Plant.appendChild(text);
   

     var Depot = document.createElement('p'); // is a node
    //  var icon= require("src/assets/icons/Depot.png");
     var icon=require("src/assets/icons/customer.png");
     var img = document.createElement('img');
     img.src = icon;
     img.width = '14';
     img.height = '14';
     Depot.appendChild(img);
     var text = document.createElement('span'); 
      text.innerHTML = ' Customer';
      // text.innerHTML = 'Depot';
      Depot.appendChild(text);
  

     var Warehouse = document.createElement('p'); // is a node
     var icon= require("src/assets/icons/warehouse.png");
     var img = document.createElement('img');
     img.src = icon;
     img.width = '12';
     img.height = '12';
     Warehouse.appendChild(img);
     var text = document.createElement('span'); 
      text.innerHTML = ' Warehouse';
      Warehouse.appendChild(text);


    controlButton.appendChild(Regional);
    // controlButton.appendChild(Head);
    controlButton.appendChild(Plant);
    controlButton.appendChild(Warehouse);
    controlButton.appendChild(Depot);

  
    return controlButton;
  }

  _mapLoaded(mapProps, map) {
 

    map.mapTypeControl = false;
    map.streetViewControl  = false;
    const centerControlDiv = document.createElement("div");
    const centerControl = this.createCenterControl(map);
    centerControlDiv.appendChild(centerControl);
    map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(centerControlDiv);
    // map.setOptions({ styles: styles['hiding'] });
//lineSymbol

    const lineSymbol = {
      path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
    };

     this.state.AllLines.map(ele=>{
      
       if(ele['target']!=null){
        var targets= JSON.parse(ele['target']);

        targets.map(tre=>{
        
          if(tre['lat']!=null && tre['lng']!=null){
                new window.google.maps.Polyline({
                  path: [
                    {lat: parseFloat(ele['source']['lat']), lng:  parseFloat(ele['source']['lng'])},
                    {lat: parseFloat(tre['lat']), lng:  parseFloat(tre['lng'])}
                  ],
                  icons: [
                    {
                      icon: lineSymbol,
                      offset: "96%",
                      // repeat: '20px'
                    },
                  ],
                  strokeColor:'rgba(255, 0, 0,0.7)',
                  anchor: new window.google.maps.Point(0, 0),
        
                  strokeWeight:'1.2',
                  scale: 0.4,
                  fillColor:"#FF0000",
                  fillOpacity:'0.35',
                  map: map,
                });
          }
        })

          //  console.log(targets);
       }
     })



 }
  

 showAlert(){
  this.setState({
    AlertVisible : !this.state.AlertVisible
  })
 }
  render() {

    if(this.state.isLoading){
      return(<>....</>
      );
    }


    return (
       <>       
      <Map google={this.props.google} zoom={4} 
      onClick={this.onMapClicked}
       
      initialCenter={{
         lat: 21.7679,
         lng: 78.8718 }} 
         onReady={(mapProps, map) => this._mapLoaded(mapProps, map)}>
          {this.state.allCompany}   
 
           <InfoWindow
             marker={this.state.activeMarker}
             visible={this.state.showingInfoWindow}>
            <div>
              <h4>{this.state.selectedPlace.name}</h4>
            </div>
        </InfoWindow>

      </Map>

           <Modal show={this.state.AlertVisible}  size="lg" >
                <Modal.Header closeButton onClick={() => this.setState({AlertVisible:false})} >
                  <Modal.Title style={{marginLeft: 'auto'}}>{this.state.markerData['title']}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <AlertComponent name={this.state.markerData['name']}/>
                </Modal.Body>

              </Modal>
       </>
    );
  }
}
 
export default GoogleApiWrapper({
  apiKey: ('AIzaSyBxCKjs-4B3s5ICMMNntriKF8ANJygUKCg')
})(MapContainer)